import React from "react";
import "../../style/statusCode.css";
import { NavLink } from "react-router-dom";


function StatusCode() {
  return (
    <div className="status-container">
      <h1>Status Codes</h1>
      <h5>This page returned a 500 status code.</h5>
      <h6>For a definition and common list of HTTP status codes,</h6>

      <h4 className="back-link">
        <NavLink to="/automation-testing">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            className="back-icon"
          >
            <path
              fill="currentColor"
              d="M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 
              7.4-17.4l176-168c9.6-9.2 24.8-8.8 
              33.9 .8s8.8 24.8-.8 33.9L83.9 232 
              424 232c13.3 0 24 10.7 24 24s-10.7 
              24-24 24L83.9 280 216.6 406.6c9.6 
              9.2 9.9 24.3 .8 33.9s-24.3 
              9.9-33.9 .8l-176-168z"
            />
            </svg>
         
          Go Back
        </NavLink>
      </h4>
    </div>
  );
}

export default StatusCode;